// extracted by mini-css-extract-plugin
export default {"container":"PostBreadcrumbs-module__container--z5-+e","animatedBackground":"PostBreadcrumbs-module__animatedBackground--HbhiW"};